export let serverURL = 'https://app.shopbox.ai'
export let imagesURL = 'https://storage.googleapis.com/shopbox-ai/images/'
export let sitecode = 'did'
export let clientID = 'did'
console.log('*',window.location.hostname,serverURL.split('.')[0])

export let availableWidgets = [undefined,'similar_sticky','welcome','similar_product_page']
// export let availableWidgets = []
// export let availableWidgets = ['similar_product_page']
export let availableMobileWidgets = ['similar_sticky','welcome']

export let debug = (window.location.hostname=='stage.did.ie') ? true : false
if (debug) {console.log('debug',debug)}


export function badUUID (uid) {
    // If there are specifc UUID's to block check for them here. Return true if they are detected
    return uid!=uid // Forces false and gets round var not used issue // (uid.substr(0,12) != 'shopbox-test')
}

export function badDomain () {
    // If you want to restrict to certain domains, check them here
    return false                // window.location.hostname.toLowerCase()=='tonykealys.co.uk'
}

export let widgets = {
    welcome : {
        widget : 'welcome',
        type : 'float',
        design : 'did_float',
        position : 'bottom_left',
        number : 3
    },
    similar_sticky : {
        widget : 'similar',
        type : 'sticky',
        design : 'did_sticky',
        position : 'bottom_left_corner',
        number : 5,
        mobileNumber : 2,
    },
    similar_product_page : {
        widget : 'similar',
        type : 'float',
        design : 'did_float',
        position : 'bottom_left_vertical',
        number : 5,
        mobileNumber : 2,
    },
    cross_sell : {
        widget : 'cross_sell',
        type : 'float',
        design : 'did_float',
        position : 'bottom_right',
        number : 4
    },
    welcome_mobile : {
        widget : 'welcome',
        type : 'float',
        design : 'did_sticky',
        position : 'bottom_mobile',
        number : 2
    },
    similar_sticky_mobile : {
        widget : 'similar',
        type : 'sticky',
        design : 'did_sticky',
        position : 'bottom_mobile',
        number : 5,
        mobileNumber : 2,
    }
}

// Styles
export let did_float = {
    // Basic appearance
    discColor : '#2fac4a',
    controlsColor : '#2fac4a',
    backgroundColor : 'white',

    // Advanced appearance
    borderLine : '2px solid',
    borderRadius: '10px',
    boxShadow : '0px 0px 10px 1px gray',
    boxShadowHover : '0px 0px 10px 1px black',
    shadowSpace : '10px',       // Needed for the shadow to not hit the edges           

    imageHeight : '120px',
    imageWidth : '120px',
    mobileImageHeight : '120px',
    mobileImageWidth : '120px',
    iconHeight : '64px',
    iconWidth : '64px',

    zIndex: 1001,
}

// export let did_inpage = {
//     // Basic appearance
//     discColor : '#2fac4a',
//     controlsColor : '#2fac4a',
//     backgroundColor : 'white',

//     // Advanced appearance
//     borderLine : 'none',
//     borderRadius: '10px',
//     boxShadow : '0px',
//     boxShadowHover : '0px',
//     shadowSpace : '0px',       // Needed for the shadow to not hit the edges           

//     imageHeight : '120px',
//     imageWidth : '120px',
//     iconHeight : '64px',
//     iconWidth : '64px',

//     zIndex: 1001,
// }


export let did_sticky = {
    // Basic appearance
    discColor : '#E30613',
    controlsColor : '#E30613',
    backgroundColor : 'white',

    // Advanced appearance
    borderLine : '2px solid',
    borderRadius: '5px',
    boxShadow : '0',
    boxShadowHover : '0',
    shadowSpace : '0',       // Needed for the shadow to not hit the edges           

    imageHeight : '120px',
    imageWidth : '120px',
    mobileImageHeight : '60px',
    mobileImageWidth : '60px',
    iconHeight : '64px',
    iconWidth : '64px',


    zIndex: 1001,
}

export let did_inpage = {
    // Basic appearance
    backgroundColor : 'white',
    border : '1px solid gray',
    controlsColor : '#E30613',
}

export let productAreas = '"image-name" "findsim" "price" "detail" "ref"'

// Positions (widgets only)

export let top_left = {
    top : '5%',
    bottom : 'auto',
    right : 'auto',
    left : '5%',
    togglePosition : 'top_left'
}


export let top_right = {
    top : '5%',
    bottom : 'auto',
    left : 'auto',
    right : '5%',
    togglePosition : 'top_right'
}

export let bottom_left = {
    bottom : '0px',
    top : 'auto',
    right : 'auto',
    left : '10px',
    togglePosition : 'bottom_left'
}

export let bottom_mobile = {
    bottom : '0',
    top : 'auto',
    right : '0px',
    left : '0px',
    togglePosition : 'top_center'
}

export let bottom_left_vertical = {
    bottom : '5%',
    top : 'auto',
    right : 'auto',
    left : '5px',
    orientation : 'vertical',
    togglePosition : 'bottom_center'
}

export let center_left = {
    bottom : 'auto',
    top : '35%',
    right : 'auto',
    left : '10px',
    togglePosition : 'center_left'
}

export let bottom_right = {
    bottom : '5%',
    top : 'auto',
    left : 'auto',
    right : '5%',
    togglePosition : 'bottom_right'
}


export let bottom_left_corner = {
    top : 'auto',
    bottom : '0px',
    left : '0px',
    right : 'auto',
    togglePosition : 'top_right'
}

export let bottom_right_corner = {
    top : 'auto',
    bottom : '0px',
    right : '0px',
    left : 'auto',
    togglePosition : 'top_left'
}

export function pageType () {
	try {
		let page = document.querySelector("meta[name='shopbox-page']").getAttribute('content')
		return page
	} catch {
		if (window.location.pathname=='/') {return 'home'}
		if (document.querySelector('.product-page-add-to-cart-button')!=undefined) {return 'detail'}
	}
}

export function detailProduct() {
	let pid = document.querySelector("meta[name='shopbox-productid']").getAttribute('content')
	return pid

}
